import { map, startsWith, propSatisfies, when } from 'ramda'

export const duration = file =>
  new Promise(resolve => {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.src = window.URL.createObjectURL(file)

    video.addEventListener('loadedmetadata', () => resolve(video.duration))
  })
const setDuration = file =>
  duration(file).then(duration => {
    file.duration = duration
    return file
  })

const isVideo = propSatisfies(startsWith('video'), 'type')
export const addDuration = map(when(isVideo, setDuration))



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/duration.js